export default __webpack_public_path__ + "static/media/dubai.2a6e7b0d.webp";